<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训设备借入</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
          <!-- <el-input v-model="formInline.training_room" clearable :placeholder="`请输入所属${$store.state.themeTitle}室`"></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="device_no" label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column  prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180px" >
        </custom-table-column>
        <custom-table-column prop="device_num" label="借入数量" width="150">
        </custom-table-column>
        <custom-table-column prop="device_price" label="设备价格（元）" width="150">
        </custom-table-column>
        <custom-table-column prop="borrow_date" label="借入日期" width="160">
        </custom-table-column>
        <custom-table-column prop="username" label="经手人" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="province" label="入库人" width="150">
        </custom-table-column> -->

        <!-- <custom-table-column  prop="reviewname" label="审核人员" min-width="160px" >
        </custom-table-column> -->

        <!-- <custom-table-column prop="phone" label="入库人电话" width="120">
        </custom-table-column>
        <custom-table-column prop="email" label="入库人邮箱" width="180">
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="设备编号" prop="device_no">
          <el-input v-model="ruleForm.device_no" placeholder="请输入设备编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称"  prop="device_name">
          <el-input v-model="ruleForm.device_name" placeholder="请输入设备名称" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="设备数量" prop="device_num">
          <el-input v-model.number="ruleForm.device_num" placeholder="请输入设备数量" style="width:198px;"></el-input> 个
        </el-form-item> -->
        <el-form-item label="设备价格" prop="device_price">
          <el-input v-model="ruleForm.device_price" placeholder="请输入设备价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <!-- <el-form-item label="设备名称" prop="device_no">
          <el-select v-model="ruleForm.device_no" style="width:216px;" filterable placeholder="请选择设备" @change="handleEqChange">
            <el-option v-for="item in eqs" :key="item.id" :label="item.device_name" :value="item.device_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="device_num" label-width="20px">
          （库存数量：{{remainder_quantity}} / 价格：{{ruleForm.device_price}}元）
        </el-form-item> -->
        <el-form-item label="借入数量" prop="device_num">
          <el-input v-model.number="ruleForm.device_num" placeholder="请输入借入数量" style="width:198px;"></el-input> 个
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'equipmentInto',
  mixins: [mixinList,mixinValidate],
  data() {
    return {
      formInline: {
        device_name: '',
        training_room:''
      },
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        device_no: '',
        device_name: '',
        device_num: 0,
        device_price: 0,
        training_room: '',
        training_no: '',
      },
      remainder_quantity: 0,
      eqs: [],
      rules: {
        device_no: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        training_no: [{ required: true, message: `请选择所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        device_num: [
          { required: true, message: '借入数量不能为空' },
          { type: 'number', message: '借入数量必须为数字值' },
        ],
        device_price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
      },
    };
  },
  components: {},
  created() {
    this.$store.dispatch('getTarinMent');
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.getEqs();
  },
  methods: {
    handleLogChange(e) {
      this.ruleForm.scrap_name = this.$until.getLabelName(this.scraps, 'isid', 'ismc', e);
    },
    async getEqs() {
      let res = await this.getDataList('getDeviceIntoList');
      this.eqs = res.data.data;
    },
    handleEqChange(val) {
      this.ruleForm.device_name = this.$until.getLabelName(this.eqs, 'device_no', 'device_name', val);
      this.remainder_quantity = this.$until.getLabelName(this.eqs, 'device_no', 'remainder_quantity', val);
      this.ruleForm.device_price = this.$until.getLabelName(this.eqs, 'device_no', 'device_price', val);
      console.log(this.ruleForm);
    },
    onSubmit() {
      console.log('submit!');
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceBorrow(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createDeviceBorrow(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getDeviceBorrowList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
